import template from './ongsList.html';
import controller from './ongsList.controller';
import './ongsList.scss';

let ongsListComponent = {
  restrict: 'E',
  bindings: {
    ongs: '<',
    onCancel: '&',
    onEdit: '&',
    onCreate : '&',
    isLoaded : '<',
  },
  template,
  controller,
};

export default ongsListComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongsList.component.js